var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 28.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.33,4.88h1.33c.18,0,.33-.17.33-.38s-.15-.38-.33-.38h-1.33c-.18,0-.33.17-.33.38s.15.38.33.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.33,7.88h1.33c.18,0,.33-.17.33-.38s-.15-.38-.33-.38h-1.33c-.18,0-.33.17-.33.38s.15.38.33.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.62,5.62h-2.25c-.21,0-.38.17-.38.38s.17.38.38.38h2.25c.21,0,.38-.17.38-.38s-.17-.38-.38-.38Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18,14.81V3c0-1.66-1.34-3-3-3s-3,1.34-3,3v11.81c-1.79,1.04-3,2.97-3,5.19,0,3.31,2.69,6,6,6s6-2.69,6-6c0-2.22-1.21-4.15-3-5.19Zm-4.08,10.08c-1.96-.41-3.51-2.03-3.85-4-.38-2.23.71-4.24,2.46-5.23.3-.17.47-.5.47-.85V3.11c0-1,.68-1.92,1.66-2.08,1.25-.2,2.34.76,2.34,1.97v11.85c0,.35.21.66.51.84,1.49.87,2.49,2.47,2.49,4.32,0,3.11-2.85,5.56-6.08,4.89Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16,16.14V6c0-.55-.45-1-1-1s-1,.45-1,1v10.14c-1.72.45-3,2-3,3.86,0,2.21,1.79,4,4,4s4-1.79,4-4c0-1.86-1.28-3.41-3-3.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.92,19.53c.04.32.08.64.08.97,0,.08,0,.15-.01.23,4.04.65,6.76,1.85,6.76,3.23,0,2.07-6.16,3.75-13.75,3.75s-13.75-1.68-13.75-3.75c0-1.37,2.72-2.57,6.76-3.23,0-.08-.01-.15-.01-.23,0-.33.03-.65.08-.97-4.79.83-8.08,2.5-8.08,4.43,0,2.76,6.72,5,15,5s15-2.24,15-5c0-1.93-3.28-3.59-8.08-4.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatBalance);
export default __webpack_public_path__ + "static/media/heat_balance.e4f2d606a6e548d416f2276cda353eff.svg";
export { ForwardRef as ReactComponent };